import React from "react";
import WeaInputNormal from "../base/wea-input-normal";
import WeaWfInput from "../base/wea-wf-input";
import WeaInputAuth from "../base/wea-input-auth";
import WeaInputLocale from "../wea-input-locale/index";
import WeaTools from "../wea-tools";
import middleware from "../../middleware";
import {
  desensitization,
  encryption,
  replaceEncryption
} from "../wea-tools/Encry.base";
class main extends React.PureComponent {
  static defaultProps = {
    inputType: "NORMAl"
  };
  static propTypes = {
    inputType: React.PropTypes.string
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const isMulti = window.localStorage.getItem("activeLanguageIds");
    const inputType = this.props.inputType.toUpperCase();
    if (inputType === "MULTILANG") {
      if (isMulti === null) {
        WeaTools.callApi(
          "/api/system/language/base/getActiveLanguage",
          "GET"
        ).then(res => {
          if (res.activeLanguageIds)
            window.localStorage.setItem(
              "activeLanguageIds",
              JSON.stringify(res.activeLanguageIds)
            );
        });
      }
    }
  }

  setValue(v = "") {
    this.refs.inputNormal && this.refs.inputNormal.setValue(v);
  }
  render() {
    const { props } = this;
    const { children, ...resProps } = props;
    let isMulti = window.localStorage.getItem("activeLanguageIds") || "[7]";
    const inputType = props.inputType.toUpperCase();
    let otherProps = {};
    try {
      isMulti = JSON.parse(isMulti);
    } catch (error) {
      isMulti = [];
      console.error("获取多语言配置信息失败", error);
    }
    let value = props.value;
    if (desensitization(value) || encryption(value)) {
      return [
        <WeaInputAuth
          {...resProps}
          ecId={`${this.props.ecId}_WeaInputAuth@i5dppd`}
        />,
        children
      ];
    }
    if (inputType === "FORM") {
      return [
        <WeaWfInput {...resProps} ecId={`${props.ecId}_WeaWfInput@nl4w35`} />,
        children
      ];
    }
    if (inputType === "MULTILANG" && isMulti.length > 1) {
      return [
        <WeaInputLocale
          {...resProps}
          ecId={`${props.ecId}_WeaInputLocale@1qpsl6`}
        />,
        children
      ];
    }
    if (
      props.type &&
      props.type.toUpperCase() === "PASSWORD" &&
      (props.viewAttr === 1 || props.viewAttr === "1")
    ) {
      // 当密码项只读时，用‘*’替换文本内容
      otherProps = {
        ...otherProps,
        value: "*".repeat(props.value ? props.value.length : 0)
      };
    }
    return [
      <WeaInputNormal
        ref="inputNormal"
        {...resProps}
        ecId={`${props.ecId}_WeaInputNormal@5zat0z`}
        {...otherProps}
      />,
      children
    ];
  }
}

const Com = middleware(main, "WeaInput");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input/index.js